import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BJIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BJ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#DD2C2B"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 0v6h16V0H0Z"
        clipRule="evenodd"
      />
      <Path fill="#5EAA22" d="M0 0h7.2v12H0z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
